import React from 'react';
import AddIngredientMenu from '../Ingredient/AddIngredientMenu';
import IngredientRow from '../Ingredient/IngredientRow';

class IngredientSection extends React.Component {
  render() {
    const {
      ingredients,
      handleAddTip,
      handleAddIngredient,
      handleSelectIngredient,
      handleRemovingIngredient,
      showTip
    } = this.props;

    return (
      <div className="ingredient-section">
        <div className="page-title">
          <h4>Ingredients</h4>
          <div className="title-action">
            <AddIngredientMenu
              handleAddTip={handleAddTip}
              handleAddIngredient={handleAddIngredient}
              showTip={showTip}
            />
          </div>
        </div>
        <ul>
          {ingredients &&
            ingredients.map((ing, index) => {
              return (
                <li key={index}>
                  <IngredientRow
                    ingredient={ing}
                    index={index}
                    handleSelectIngredient={handleSelectIngredient}
                    handleRemovingIngredient={handleRemovingIngredient}
                  />
                </li>
              );
            })}
        </ul>
      </div>
    );
  }
}

export default IngredientSection;
